import { useState, useEffect } from 'react';
import i18n from '../../i18n';
import { motion } from 'framer-motion';

export default function LanguageToggle() {
    const [lang, setLang] = useState(i18n.language);

    useEffect(() => {
        const handleChange = (lng: string) => setLang(lng);
        i18n.on('languageChanged', handleChange);
        return () => { i18n.off('languageChanged', handleChange); };
    }, []);

    const isHindi = lang === 'hi';

    const toggle = () => {
        i18n.changeLanguage(isHindi ? 'en' : 'hi');
    };

    return (
        <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={toggle}
            className="relative w-10 h-10 rounded-full transition-colors duration-300 group flex items-center justify-center"
            style={{
                border: '2px solid transparent',
                background: 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #b8860b, #7c3aed, #db2777) border-box',
            }}
            aria-label={isHindi ? 'Switch to English' : 'हिन्दी में बदलें'}
            title={isHindi ? 'Switch to English' : 'हिन्दी में बदलें'}
        >
            <span
                className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ background: 'linear-gradient(135deg, rgba(184,134,11,0.1), rgba(124,58,237,0.1), rgba(219,39,119,0.1))' }}
            />
            <span className="relative z-10 text-sm font-bold font-poppins leading-none" style={{ color: '#8B6914' }}>
                {isHindi ? 'EN' : 'हि'}
            </span>
        </motion.button>
    );
}
